import { analyticsApi } from "../AxiosInstance";


export function getDurationOfDeliveryApi(params) {
  return analyticsApi().get(`/analytics/v1/durationOfDelivery?start=${params.start}&end=${params.end}&interval=${params.interval}${params.driverUserId ? `&driverUserId=${params.driverUserId}` : ""}`);
}

export function getAnalyticsApi(params) {
  return analyticsApi().get(`/analytics/v1/overall?start=${params.start}&end=${params.end}&interval=${params.interval}${params.driverUserId ? `&driverUserId=${params.driverUserId}` : ""}`);
}

export function getAccuracyOfDeliveryApi(params) {
  return analyticsApi().get(`/analytics/v1/accuracyOfDelivery?start=${params.start}&end=${params.end}&interval=${params.interval}${params.driverUserId ? `&driverUserId=${params.driverUserId}` : ""}`);
}

export function getDistanceOfDeliveryApi(params) {
  return analyticsApi().get(`/analytics/v1/distanceOfDelivery?start=${params.start}&end=${params.end}&interval=${params.interval}${params.driverUserId ? `&driverUserId=${params.driverUserId}` : ""}`);
}

export function getMissionStatusApi(params) {
  // console.log("interval", params.interval)
  return analyticsApi().get(`/analytics/v1/missionStatus?start=${params.start}&end=${params.end}&interval=${params.interval}${params.driverUserId ? `&driverUserId=${params.driverUserId}` : ""}`);
}
